<template>
	<div class="container-wrap">
		<div class="container">
			<div class="banner-wrap">
				<div class="swiper-container banner" v-if="bannerList.length>0">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="item in bannerList" :key="item.id">
							<img @click="bannerLink(item)" :src="item.picUrl"/>
						</div>
					</div>
					<div class="swiper-pagination"></div>
				</div>
				<div class="notcie-wrap" >
					 <div class="notice-arrow notice-arrow-l"></div>
					 <div class="notice">
						<Title title="动态"></Title>
						<ul v-if="newsList.length>0">
							<li @click="toNewsDetail(item)" v-for="item in newsList" :key="item.id">
								<div class="notice-title" :title="item.title">{{item.title}}</div>
								<div class="notice-txt">
									{{item.introduction}}
								</div>
							</li>
						</ul>
					 </div>
					 <div class="notice-arrow notice-arrow-r"></div>
				</div>
			</div>
			<!--推荐视频-->
			<div class="wrap video-wrap">
				<Title title="视频">
					<!-- <div class="title-more" slot="title-more">
						<a href="#">更多</a>
						<i class="el-icon-arrow-right"></i>
					</div> -->
				</Title>
				<VideoHome v-if="videoList.length>0" :list="videoList" @toDetail="toVideoDetail"/>
			</div>
			<div class="wrap document-wrap">
				<Title title="文档"></Title>
				<DocumentHome v-if="documentList.length>0" :list="documentList" @toDetail="toDocumentDetail"/>
			</div>
			<div class="wrap">
				<Title title="友情链接"></Title>
				<ul class="partner" v-if="linksList.length>0">
					<li v-for="item in linksList">
						<a :href="item.linkUrl" target="_blank"><img :title="item.linkName" :src="item.picUrl"/></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import navTop from '@/components/product/navTop'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Swiper from "swiper"
	import 'swiper/dist/css/swiper.css'
	import Title from '@/components/product/title'
	import DocumentHome from '@/components/product/index/documentHome'
	import VideoHome from '@/components/product/index/videoHome'
	import DownHome from '@/components/product/index/downHome'
	import homeModule from '@/modules/product/home.js'
	export default {
		name: 'Home',
		components: {
			navTop,
			Title,
			DocumentHome,
			VideoHome,
			DownHome
		},
		mixins: [
			homeModule
		],
		data() {
			return {
				isfixTab: false,
				currentId: '',
				menuList:[],
				bannerList: [],
				newsList: [],
				videoList: [],
				documentList: [],
				linksList: []
			}
		},
		created(){
			// this.getDataList()
			this.getHomeData()
			this.getConfigData()
			setTimeout(()=>{
				document.title =this.logoTitle
			},300)
		},
		methods: {
			bannerLink(item){
				if(item.linkCode=='nil') {
					return
				} else if(item.linkCode=='link') {
					window.open(item.linkUrl)
					return
				} else {
					this.$router.push({
						path: item.linkRoute
					})
				}
			},
			toDocumentDetail(e){
				this.$router.push({
					path: '/singleDocument/'+e.columnId+'/'+e.id
				})
			},
			toNewsDetail(item){
				this.$router.push({
					path: '/newsDetail/'+item.columnId+'/'+item.id
				})
			},
			toVideoDetail(e){
				this.$router.push({
					path: '/videoDetail/'+e.columnId+'/'+e.id
				})
			},
			//获取轮播等数据
			async getHomeData(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/column/homeData', qs.stringify(param))
				if(res.data.code==200){
					let entity = res.data.entity
					this.bannerList = entity.bannerList
					this.newsList = entity.newsList
					this.videoList = entity.videoList
					this.documentList = entity.documentList
					this.linksList = entity.linksList
					setTimeout(res=>{
						this.initSwiper()
					},300)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			initSwiper(){
				new Swiper(".banner", {
					autoplay: 6000,
					autoplayDisableOnInteraction : false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable :true
				})
			},
			async getDataList(){
				let param = {
					documentId: 10
				}
				ajaxParam(param)
				const res = await post('v1/document/documentAnchor', qs.stringify(param))
				if(res.data.code==200){
					this.menuList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleNodeClick(data) {
				//console.log(data)
			},
			handleTabFix() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				scrollTop > 160 ? this.isfixTab = true : this.isfixTab = false
				let nav = document.querySelector('#ant-anchor-ink-ball')
				let cnt = document.querySelectorAll('.content-item')
				let anchorLink = document.querySelectorAll('.anchor-link-title')
				//var offsetTop = document.querySelector('#nav-sub').offsetTop
				for(let i=0; i<cnt.length; i++){
					if(cnt[i].offsetTop<=scrollTop) {
						let a = cnt[i].id
						for(let j=0; j<anchorLink.length; j++)
						{
							let href= anchorLink[j].href
							let index = href.indexOf('#')
							href=href.substring(index+1,href.length)
							if(href==a) {
								this.currentId = anchorLink[j].id
								let b = document.getElementById(anchorLink[j].id)
								nav.style.top = (b.offsetTop-8)+'px'
							}
						}

						//this.handlechange()
					}
				}
			},
			todetail(id){
				this.currentId = id
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleTabFix, true)
		}
	}
</script>
<style scoped lang="less">
	@import './product.less';
	.banner-wrap{
		position: relative;
		padding: 10px 0;
		height: 316px;
		.banner{
			height:  316px;
			img{
				width:100%;
				height: 100%;
			}
		}
		.notcie-wrap{
			width: 346px;
			height: 332px;
			display: flex;
			justify-content: center;
			position: absolute;
			top: 2px;
			right: 52px;
			z-index: 9;
			.notice {
				width: 330px;
				height: 100%;
				background: #fff;
				box-shadow: 0 6px 11px 0 rgba(75,121,189,.2);
				ul li{
					height: 89px;
					border-bottom: 1px solid hsla(0,0%,59%,.1);
					padding: 12px 26px;
					box-sizing: border-box;
					cursor: pointer;
					.notice-title{
						margin-bottom: 6px;
						line-height: 22px;
						letter-spacing: 1.14px;
						font-size: 16px;
						color: #3b3b3b;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-wrap: normal;
						font-weight: 500;
					}
					.notice-txt{
						font-size: 12px;
						line-height: 17px;
						color: #606060;
						letter-spacing: .86px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
				}

			}
			.notice-arrow {
				width:0;
				height: 0;

			}
			.notice-arrow-l {
				border-top: 8px solid #c3c7bb;
				border-left: 8px solid transparent;
				transform: rotate(90deg);
			}
			.notice-arrow-r {
				border-bottom: 8px solid #c3c7bb;
				border-right: 8px solid transparent;
			}
		}
	}

	.title-more {
		height: 30px;
		line-height: 30px;
		color: #1075e7;
		cursor: pointer;
		font-weight: 400;
		a {
			color: #1075e7;
		}
	}
	.wrap .title {
		border-bottom: none!important;
		padding-bottom: 10px!important;
	}
	.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
		bottom: 10px
	}
	/deep/ .swiper-pagination-bullet-active{
		width: 20px!important;
		border-radius: 4px;
	}
	.partner{
		display: flex;
		flex-wrap: wrap;
		li{
			img{
				height: 38px;
				margin: 20px 80px 20px 0;
			}
		}
	}
</style>
